export default __webpack_public_path__ + "static/launch-partner_SilverPoet_right@2x-6f901e0fb86b915522ebfd48855fd5f9.jpg";